import { createAsyncThunk } from '@reduxjs/toolkit'

import { IWalletEvent, IWalletEventMetadata } from 'meta/pages/v4/wallet'
import { WalletController } from 'controller/wallet'
import { RootState } from 'store/types'

type Params = {
  page: number
}

type Returned = { events: Array<IWalletEvent>; metadata: IWalletEventMetadata }

export const getPastEvents = createAsyncThunk<Returned, Params, { state: RootState }>(
  'wallet/past/events',
  async (params) => {
    const { page } = params

    const { items, metadata } = await WalletController.getPastEvents({ page })

    return { events: items, metadata }
  }
)
